module.exports = __webpack_public_path__ + "static/media/mainpng.0d85c875.png";